import { Box, Grid, Typography } from '@material-ui/core';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import React from 'react';
import { Card, CardText } from 'react-md';
import { COMPANY_COLORS } from '../../../config/consts';
import ButtonPrimary from '../buttons/ButtonPrimary';

export function OnboardingCard(props) {
  const style = {
    width: props.width || 290,
    height: props.height || 580,
    marginBottom: 20,
    marginLeft: 50,
    borderRadius: 6,
    boxShadow:
      '0px 16px 8px -4px rgba(0,0,0,0.05), 0px 13px 19px 2px rgba(0,0,0,0.05), 0px 5px 24px 4px rgba(0,0,0,0.05)',
  };

  const { condition, title, text, buttonLabel, history, onClickButton } = props;

  return (
    <Card style={style} className="md-block-centered">
      <Grid container spacing={3} style={{ marginBottom: 50 }}>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="center" mt={6}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              style={{
                borderRadius: '50%',
                height: 60,
                width: 60,
                background: condition ? '#ababab' : COMPANY_COLORS.primary,
              }}
            >
              <BookmarkIcon
                style={{
                  color: 'white',
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Grid container style={{ marginBottom: 10 }} spacing={3}>
        <Grid item xs={12}>
          {props.multipleLines ? (
            <Box display="flex" justifyContent="center" alignItems="center">
              <textarea
                style={{
                  outline: 'none',
                  border: 'none',
                  width: '100%',
                  height: '120px',
                  resize: 'none',
                  fontWeight: 500,
                  fontSize: 16,
                  textAlign: 'center',
                  marginLeft: style.width / 15,
                  marginRight: style.width / 15,
                }}
                spellcheck="false"
                value={title}
              />
            </Box>
          ) : (
            <Typography
              style={{
                fontWeight: 200,
                fontSize: 16,
                textAlign: 'center',
                marginLeft: style.width / 15,
                marginRight: style.width / 15,
              }}
            >
              {title}
            </Typography>
          )}
        </Grid>
      </Grid>
      <CardText>
        <Grid container spacing={3} style={{ marginBottom: 20 }}>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="center">
              <Typography
                variant="caption"
                style={{
                  textAlign: 'center',
                  color: '#ABABAB',
                  marginLeft: 20,
                  marginRight: 20,
                }}
              >
                {text}
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              padding: '0 30px',
            }}
          >
            {props.aditionalContent1}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              padding: 0,
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            {props.aditionalContent2}
          </Grid>
        </Grid>
      </CardText>
      {!props.hideButton && (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="center">
              <ButtonPrimary
                type="submit"
                history={history}
                onClick={onClickButton}
                disabled={condition ? true : false}
              >
                {buttonLabel}
              </ButtonPrimary>
            </Box>
          </Grid>
        </Grid>
      )}
    </Card>
  );
}
